import { createGlobalStyle, css } from 'styled-components';

// @ts-ignore
import RobotFont from './fonts/roboto/roboto-regular.ttf';
// @ts-ignore
import ZainFont from './fonts/zain/zain-regular.ttf';
import { Rounded } from './theme/Rounded';

const fontFaces = css`
  @font-face {
    font-family: 'Roboto';
    src: url(${RobotFont});
    unicode-range: U+0000-00FF, U+0100-024F;
  }

  @font-face {
    font-family: 'Zain';
    src: url(${ZainFont});
    unicode-range: U+0600-06FF, U+0750-077F, U+08A0-08FF, U+FB50-FDFF,
      U+FE70-FEFF, U+0660-0669;
  }
`;

export const GlobalStyle = createGlobalStyle`
:root {
  --atira-main: #652d90;
  --atira-sub: #ebebeb;
  --atira-light-main: #934599;
  --atira-font-size-heading-xl: clamp(2rem, calc(4vw + 1rem), 3.5rem);
  --atira-font-size-heading: clamp(1.6rem, calc(3vw + 0.5rem), 2.5rem);
  --atira-font-size-sub-heading: clamp(1.3rem, calc(1.25vw + 0.5rem), 2rem);
  --atira-font-size-body: clamp(1rem, calc(1vw + 0.25rem), 1.125rem);
  --atira-font-size-small: clamp(0.875rem, calc(0.75vw + 0.25rem), 1rem);
  --atira-font-size-note: clamp(0.75rem, calc(0.5vw + 0.25rem), 0.875rem)
}

p, h1, h2, h3, h4, h5, h5 {
  margin: 0 !important;
}

::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

::-webkit-scrollbar-track {
  background: var(--atira-sub);
}

::-webkit-scrollbar-thumb {
  background: var(--atira-light-main);
  border-radius: ${Rounded.xl};
}

::-webkit-scrollbar-thumb:hover {
  background: var(--atira-main);
}

${fontFaces}

/* Hidden elements to ensure fonts are loaded */
.hidden-fonts-zain {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  font-family: 'Zain', sans-serif;
  height: 0;
  width: 0;
}

.hidden-fonts-roboto {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  font-family: 'Roboto', sans-serif;
  height: 0;
  width: 0;
}

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html,
body,
#root {
  height: 100%;
  width: 100%;

  height: 100vh;
}

/*  */

.ant-layout .ant-layout-sider,
.ant-layout .ant-layout-sider-trigger {
  background-color: #000;
}

.ant-spin-dot-item {
  background-color: var(--atira-main) !important;
}

.ant-dropdown-menu .ant-dropdown-menu-item.logout-button {
  transition: none !important;
}

.ant-dropdown-menu .ant-dropdown-menu-item.logout-button:hover {
  background-color: transparent !important;
}

.sidemenu-notifications {
  overflow: visible !important;
}
`;
